module.exports = __webpack_public_path__ + "img/carne-header-mobile-ap3.7d144cde.png";